export default __webpack_public_path__ + "static/media/portfolio.d99176a8.png";